import { useState } from 'react';
import { PlayMode, Game } from './types';

type StartParams = {
  game: Game;
  playMode: PlayMode;
  opened: boolean;
};

export type GameStarter = StartParams & {
  opened: boolean;
  openRealGame: (game: Game) => void;
  openPracticeGame: (game: Game) => void;
  close: () => void;
};

const useGameStarter = (): GameStarter => {
  const [startParams, setStartParams] = useState<StartParams>({
    playMode: 'practice',
    game: {} as Game,
    opened: false,
  });

  const openRealGame = (game: Game) => {
    setStartParams({ game, playMode: 'real', opened: true });
  };

  const openPracticeGame = (game: Game) => {
    setStartParams({ game, playMode: 'practice', opened: true });
  };

  const close = () => {
    setStartParams((prev) => ({ ...prev, opened: false }));
  };

  return {
    ...startParams,
    openRealGame,
    openPracticeGame,
    close,
  };
};

export default useGameStarter;
